import blockchainAndWeb3Icon from '../../../public/svg/icons/rustIndustriesWeServe/blockchainAndWeb3.svg';
import fullStackCapabilityIcon from '../../../public/svg/icons/rustWhyRF/fullStackCapability.svg';
import pragmaticApproachIcon from '../../../public/svg/icons/rustWhyRF/pragmaticApproach.svg';
import productionRustExpertiseIcon from '../../../public/svg/icons/rustWhyRF/productionRustExpertise.svg';
import transparentCommunicationIcon from '../../../public/svg/icons/rustWhyRF/transparentCommunication.svg';

export const whyChooseRFData = [
  {
    title: 'Production Rust Expertise',
    description: `We've been building Rust applications since before it was cool. Our team has battle-tested experience deploying Rust in production environments.`,
    img: productionRustExpertiseIcon,
  },
  {
    title: 'Blockchain Background',
    description: `Our work in blockchain development, where performance and security are non-negotiable, has made us experts in writing robust, efficient Rust code. We bring that rigor to every web application we build.`,
    img: blockchainAndWeb3Icon,
  },
  {
    title: 'Full-Stack Capability',
    description: `We don't just write backend code. We understand frontend frameworks, DevOps practices, and system architecture. You get a complete solution, not just a component.`,
    img: fullStackCapabilityIcon,
  },
  {
    title: 'Pragmatic Approach',
    description: `We know when Rust is the right choice and when it isn't. If another technology fits your needs better, we'll tell you. Our goal is your success, not using the shiniest tools.`,
    img: pragmaticApproachIcon,
  },
  {
    title: 'Transparent Communication',
    description: `You'll always know where your project stands. Regular updates, honest timelines, and no surprises. We're partners in your project, not just contractors.`,
    img: transparentCommunicationIcon,
  },
];
